"use client";

import { HStack } from "@chakra-ui/react";
import {
  PaginationItems,
  PaginationNextTrigger,
  PaginationPrevTrigger,
  PaginationRoot,
} from "./pagination.tsx";

interface CustomPaginationProps {
  count: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (pageIndex: number) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
  canNextPage: boolean;
  canPreviousPage: boolean;
  siblingCount?: number;
}

export const CustomPagination = ({
  count,
  pageSize,
  currentPage,
  onPageChange,
  onNextPage,
  onPreviousPage,
  canNextPage,
  canPreviousPage,
  siblingCount = 1,
}: CustomPaginationProps) => {
  // Convert pageIndex (0-based) to page number (1-based) for PaginationRoot
  const pageNumber = currentPage + 1;

  return (
    <PaginationRoot
      count={count}
      pageSize={pageSize}
      page={pageNumber}
      siblingCount={siblingCount}
      defaultPage={pageNumber}
    >
      <HStack wrap="wrap" justify="center">
        <PaginationPrevTrigger
          onClick={onPreviousPage}
          disabled={!canPreviousPage}
        />
        <PaginationItems onPageChange={onPageChange} />
        <PaginationNextTrigger onClick={onNextPage} disabled={!canNextPage} />
      </HStack>
    </PaginationRoot>
  );
};
